import { steps } from '@/mocks/home';

export default function HowToUse() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            快速上手指南
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            只需四步，即可轻松掌握 17c 的核心操作流程
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[calc(12.5%+24px)] right-[calc(12.5%+24px)] h-0.5 bg-background-300"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {steps.map((item, index) => (
              <div key={index} className="relative flex flex-col items-center text-center">
                <div className="relative z-10 w-16 h-16 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl font-bold mb-5">
                  {item.step}
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}